<section>
    <div class="container">
        <div class="row m-b-2">
            <div class="col-md-6 col-md-offset-3">
                <h4 class="activities-sidbar">Ingreso</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-md-offset-3">

                <form [formGroup]="loginForm">
                    <div class="row">
                        <div class="col-md-10 form-group item-form">
                            <label for="usuario">Usuario</label>
                            <input type="text" name="user" class="form-control" id="usuario" required=""
                                aria-required="true" formControlName="usuario">
                            <p class="help-block error hidden">Ingresá tu usuario</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-10 form-group item-form">
                            <label for="password">Contraseña</label>
                            <input id="password" type="password" class="form-control" name="password"
                                formControlName="password">
                            <p class="help-block error hidden">Ingresá tu contraseña</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <button [ngClass]="{ 'state-loading': formEnviando && loginForm.valid }" type="button"
                                class="btn btn-success" [disabled]="loginForm.invalid"
                                (click)="login()">INGRESAR</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-10">
                            <hr>
                            <div id="errores" *ngIf="mostrarError" aria-live="polite" class="alert alert-danger">
                                <h5>{{mensajeError}}</h5>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</section>